import BaseResource from './BaseResource'
import { Subcategory } from 'types'

export default class Subcategories extends BaseResource<Subcategory> {
  endpoint = 'v1/subcategories'
}
